import { Grid } from '@mui/material';
import FieldSelect from '../../../../../components/general/fields/fieldSelect';
import FieldText from '../../../../../components/general/fields/fieldText';
import DatePickerField from '../../../../../components/general/fields/datePickerField';
import { useAccountDetailGeneralInfo } from './hook';
import { Checkbox } from '../../../../../components/general/fields/checkbox';
import Loading from '../../../../../components/general/loadings/loading';
import { AccountDetailGeneralInfoProps } from './props';

export const AccountDetailGeneralInfo = ({
    loading,
    account,
}: AccountDetailGeneralInfoProps) => {
    const {
        formik,
        typesPerson,
        typesDocument,
        cities,
        typeContactPersons,
        genders,
    } = useAccountDetailGeneralInfo(account);
    return loading ? (
        <Loading />
    ) : (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
        >
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Identificación"
                    name="document"
                    size="small"
                    value={formik.values.document}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldSelect
                    data={typesPerson}
                    label="Tipo de persona"
                    name="personType"
                    size="small"
                    value={formik.values.personType as string}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldSelect
                    data={typesDocument}
                    label="Tipo de documento"
                    name="typeDocument"
                    size="small"
                    value={formik.values.typeDocument as string}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Nombre / Razón social"
                    name="name"
                    size="small"
                    value={formik.values.name}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldSelect
                    data={genders}
                    label="Género"
                    name="gender"
                    size="small"
                    disabled
                    value={formik.values.gender as string}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Checkbox
                    // isCheckMode={true}
                    beforeLabel="LGBTIQ"
                    label="¿Se identifica como LGBTIQ?"
                    disabled
                    checked={account?.isLGBTIQ}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Celular"
                    name="cellPhone"
                    size="small"
                    value={formik.values.cellPhone}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Teléfono"
                    name="phone"
                    size="small"
                    value={formik.values.phone}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="E-mail"
                    name="email"
                    size="small"
                    value={formik.values.email}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldSelect
                    data={cities}
                    label="Ciudad dirección"
                    name="city"
                    size="small"
                    value={formik.values.city}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Dirección georreferenciación"
                    name="address"
                    size="small"
                    value={formik.values.address}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <DatePickerField
                    label="Fecha de nacimiento"
                    name="birthdate"
                    size="small"
                    disabled
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Checkbox
                    beforeLabel="Condición especial"
                    label="¿Presenta alguna condición especial?"
                    disabled
                    checked={Boolean(
                        account?.specialCondition?.hasSpecialCondition
                    )}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldSelect
                    data={typeContactPersons}
                    label="Tipo de persona contacto"
                    name="typeContactPerson"
                    size="small"
                    value={formik.values.typeContactPerson as string}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Checkbox
                    beforeLabel="La persona de contacto"
                    label="¿Es cliente?"
                    disabled
                    checked={Boolean(account?.contactType?.isClient)}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Checkbox
                    beforeLabel="Utilización datos contacto"
                    label="Hábeas data"
                    disabled
                    checked={Boolean(account?.contactType?.acceptsHabeasData)}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Checkbox
                    beforeLabel="La persona de contacto"
                    label="¿Es activa?"
                    disabled
                    checked={Boolean(account?.active)}
                />
            </Grid>
        </Grid>
    );
};
